import React from 'react';
import ProbabilityForecastWidgetBuilder from './ProbabilityForecastWidgetBuilder';
import ProbabilityForecastWidgetRenderer from './ProbabilityForecastWidgetRenderer';
import Preview from './Preview';
import Summary from './Summary';
import type { WidgetDefinition } from '../../../registry';
import type {
  ProbabilityForecastWidgetConfig,
  ProbabilityForecastDataContent,
} from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercent } from '@fortawesome/free-solid-svg-icons';

export { default as ProbabilityForecastWidgetBuilder } from './ProbabilityForecastWidgetBuilder';
export { default as ProbabilityForecastWidgetRenderer } from './ProbabilityForecastWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'probability_forecast',
  meta: {
    label: 'Price-Move Forecast',
    icon: React.createElement(FontAwesomeIcon, { icon: faPercent }),
    description: 'Capture P(stock up after the print) — Brier-scored against the realized move',
    isSystem: true,
    isCreatable: false,
    shareable: true,
    editableInWorkflow: true,
    dataFlow: 'input',
    summaryEligible: true,
    lastUpdated: '2026-06-13',
  },
  defaultSize: { w: 2, h: 2, minW: 2, minH: 2 },
  defaultConfig: () => ({
    resolutionWindow: 1,
  } as ProbabilityForecastWidgetConfig),
  Builder: ProbabilityForecastWidgetBuilder,
  Renderer: ProbabilityForecastWidgetRenderer,
  Preview,
  Summary,
  sampleSummaryData: [
    { probUp: 0.8 },
    { probUp: 0.5 },
    { probUp: 0.2 },
    undefined,
  ],
  validate: (data: unknown): string[] => {
    const content = data as ProbabilityForecastDataContent | undefined;
    if (typeof content?.probUp !== 'number') {
      return ['A probability is required'];
    }
    if (content.probUp < 0 || content.probUp > 1) {
      return [`Invalid probability "${content.probUp}"`];
    }
    return [];
  },
};
